import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import LineChartWidget from 'widgets/charts/LineChartWidget'
import DiscountChartTooltip from 'widgets/charts/DiscountChartTooltip'

export default function DiscountsChartLoader () {
  const entries = useValue('entries', [])

  const lines = [
    {
      dataKey: 'employee_percentage',
      stroke: '#e15b5b'
    },
    {
      dataKey: 'onthehouse_percentage',
      stroke: '#69b3e4'
    },
    {
      dataKey: 'discount_percentage',
      stroke: '#af7bc4'
    }
  ]

  return (
    <LineChartWidget
      data={entries}
      lines={lines}
      tooltipContent={<DiscountChartTooltip/>}
      xTick={{
        type: 'time',
        mode: 'monthly',
      }}
      yTick={{
        type: 'percentage',
      }}
      xDataKey='timestamp'
    />
  )
}
